"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecorderServer = isRecorderServer;
/**
 * Which server this page came from. The recorder-only server (src/server/recorder-app.ts) names
 * itself in its unauthenticated /health; the trading server does not.
 */
const request_1 = require("./request");
const TIMEOUT_MS = 5000;
/** Never throws: any failure reads as not the recorder, so nothing extra is shown. */
async function isRecorderServer() {
    try {
        const res = await fetch(`${(0, request_1.getApiBaseUrl)()}/health`, { signal: AbortSignal.timeout(TIMEOUT_MS) });
        if (!res.ok)
            return false;
        const body = (await res.json());
        return body?.service === "recorder";
    }
    catch {
        return false;
    }
}
